export default {"src":"/_next/static/media/logo_easycapital.6c739a70.svg","height":51,"width":324};